import { render } from "./TrailerAerial.vue?vue&type=template&id=4874d42f&scoped=true"
import script from "./TrailerAerial.vue?vue&type=script&lang=js"
export * from "./TrailerAerial.vue?vue&type=script&lang=js"

import "./TrailerAerial.vue?vue&type=style&index=0&id=4874d42f&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4874d42f"]])

export default __exports__